var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "group-page-menu-sharing" }, [
    _c("div", [
      _c("div", { staticClass: "text-center" }, [
        _c("span", { staticClass: "group-page-menu-sharing__header" }, [
          _vm._v("\n                " + _vm._s(_vm.group.name)),
          _c("br"),
          _vm._v("\n                Sharing Dashboard\n            "),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticStyle: { "text-align": "center" } },
      _vm._l(_vm.items, function (item) {
        return _c("group-page-menu-sharing-panel-item", {
          key: item.iconClass,
          attrs: { item: item },
        })
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }